import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const paloAltoPanOs = defineConnector({
  identifier: "paloAltoPanOs",
  name: "Palo Alto Networks PAN-OS",
  tagLine: "Firewall and network security management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => headerAuth([{ name: "X-PAN-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key by making a request to your firewall: `curl -k 'https://<firewall>/api/?type=keygen&user=<user>&password=<pass>'`. Copy the key from the response. Alternatively, use the **API Key** page in the PAN-OS web interface.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Firewall host",
          required: true,
          placeholder: "firewall.example.com",
          helperText:
            "Your PAN-OS firewall or Panorama hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key generated from your PAN-OS device.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => ({
      url: `https://${host}/api/?type=version`,
      expectedBodyContains: 'status="success"',
    }),
  },
});
